<div class="dialog-header">
  <div class="flex items-center gap-3">
    <div class="icon-container">
      <mat-icon [ngStyle]="{'color': l_backgroundColor || '#0f172a'}">info_outline</mat-icon>
    </div>
    <h3 mat-dialog-title class="dialog-title" [ngStyle]="{'color': l_backgroundColor || '#0f172a'}">{{ l_title }}</h3>
  </div>
  <button mat-icon-button class="close-icon-btn" (click)="lFN_closeDialog();">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content custom-scrollbar">
  <div *ngIf="!lFN_IsHtml(l_message)" class="text-message">{{ l_message }}</div>
  <div *ngIf="lFN_IsHtml(l_message)" [innerHTML]="l_message" class="html-message"></div>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button class="btn-close-modern" (click)="lFN_closeDialog();">Close</button>
</div>